import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserLocalSelectionService } from 'src/app/services/dataServices/user-local-selection-service/user-local-selection.service';

@Component({
    selector: 'app-registry-confirmation',
    templateUrl: './registry-confirmation.component.html',
    styleUrls: ['./registry-confirmation.component.scss'],
    standalone: false
})
export class RegistryConfirmationComponent implements OnInit {

  constructor(public router: Router, private localSelectionService: UserLocalSelectionService) { }

  @HostListener('window:beforeunload')
  onBeforeUnload() {
      // Delets Data if tab was closed
      this.localSelectionService.clearSelection('selectedPackage-register');
  }

  ngOnInit(): void {
  }

  routeToMarketplace() {
  //   if (this.userService.loggedIn) {
  //     this.headerService.setActiveProvider(this.activeProvider[0], true);
  // } else {
      this.router.navigate(['marktplatz']);
  // }
  // this.cd.detectChanges();
  }

}
